<template>
  <section class="bg-primary">
    <div class="container ">
      <div class="section-title page-title ">
        <div class="content">
          <h2 class="title h2-caslon text-white text-center f-44 fw-600">EV battery components</h2>
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page">
    <div class="container">
      <div class="page-content pb-0">

        <ContentsTextWithImage
          title="Properties"
          image-url="/pages/products/industries/Screen-Shot-2565-05-19-at-15.02.20.png"
          :contents="[
            'PEI or Ultem™ is amorphous polymer and is one of the highest heat plastics among transparent materials. Its outstanding advantages are high heat resistance (Tg 217-247c, RTI 180c), good chemical resistance except strong base, low CTE, low shrinkage, lightweight (Sg 1.27), high strength at elevated temperature, inherent flame retardancy, and IR transparency.',
          ]"
          is-reverse="true"
          is-content-small-text="true"
          left-width="43.444%"
          right-width="56.252%"
        />
        
      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-bottom">
    <div class="container">
      <div class="page-content">

        <ContentsTextWithImage
          title="Applications"
          image-url="/pages/products/industries/Screen-Shot-2565-05-19-at-15.02.20.png"
          :contents="[
            'With its unique properties, PEI is used in applications where requirements are stringent such as high precision parts with tight tolerance or metal replacement, and in harsh environments such as hot and cold temperature, strong chemical exposure. PEI is well known for glasses frame because of its lightweight and high strength, hard disk drive components, 5G antenna, ADAS lenses, fuel pump, throttle body for automotive, valves in fluid engineering, food service, interior mass transportation cabin due to FST requirements, medical equipment that require maximum sterilization, and thin wall parts where strength is needed',
          ]"
          is-content-small-text="true"
          left-width="43.444%"
          right-width="56.252%"
        />
        
      </div>
    </div>
  </section>

</template>

<script setup></script>

<style scoped>
.page-title {
  padding: 60px 0;
}

.page-title .title {
  margin: 30px 0;
}

.section-bottom .page-content {
  padding: 60px 0;
}
</style>
